import jqueryValidation from "./../../libs/jquery/jquery.validate";
// import ownReCaptcha from "./../../libs/own-modules/ownReCaptcha";

//auth section
$("#loginBtn").click((e) => {
    e.preventDefault();
    $("#loginForm").submit();
});

$("#forgotBtn").click((e) => {
    e.preventDefault();
    $("#forgotForm").submit();
});

$("#regBtn").click((e) => {
    e.preventDefault();
    $("#regForm").submit();
});

let jqValidateTimer = 0;
function jqValidateOnkeyup(element, event, force) {

    const excludedKeys = [
            16, 17, 18, 20, 35, 36, 37,
            38, 39, 40, 45, 144, 225
        ],
        rules = $(element).rules();

    clearTimeout(jqValidateTimer);

    if (rules.remote && typeof(force) === "undefined") {
        jqValidateTimer = setTimeout(function () {
            $.validator.defaults.onkeyup.apply(this, [element, event, true]);
        }.bind(this), 600);
        return;
    }

    if ( event.which === 9 && this.elementValue( element ) === "" || $.inArray( event.keyCode, excludedKeys ) !== -1 ) {
        return;
    } else if ( element.name in this.submitted || element.name in this.invalid ) {
        this.element( element );
    }
}

// console.log(AT_MESSAGES);
$("#loginForm").validate({
    onkeyup: jqValidateOnkeyup,
    errorElement: "div",
    errorClass: "invalid-feedback",
    rules: {
        login: {
            required: true
        },
        password: {
            required: true
        }
    },
    messages: {
        login: {
            required: jQuery.validator.format("This field is required")
        },
        password: {
            required: jQuery.validator.format("This field is required")
        }
    },
    submitHandler(form) {
        // console.log("submitHandler");
        $("#loginBtn").attr("disabled", true);
        const $form = $(form);
        $("#logInd").css("display","inline-block");
        $(".checker, .error", $form).text("");

        $.ajax({
            url: form.action,
            type: form.method,
            data: $(form).serialize(),
            success: (response) => {
                location.href = response.successUrl ? response.successUrl : "/dashboard";

                $("#loginBtn").attr("disabled", false);
                $("#logInd").css("display","none");
            },
            error: (error) => {
                const $error = error.responseJSON,
                    check_fields = '<div class="checker"></div>\n' +
                    // '                    <%--Telegram code--%>\n' +
                    '                    <div id="codeBlock" class="form-group" style="display: none">\n' +
                    '                        <label for="codeBlock">' + AT_MESSAGES["index.telegram.code"] + '</label>\n' +
                    '                        <input class="form-control" type="text" name="code" id="code" value="" autocomplete="off" data-lpignore="true">\n' +
                    '                        <div id="resendTelegramCode" class="btn auth-group send-new-code m-15-0-0">' + AT_MESSAGES["index.telegram.code.resend"] + '</div>\n' +
                    '                    </div>\n' +
                    // '                    <%--google 2fa code--%>\n' +
                    '                    <div id="googleCodeBlock" class="form-group" style="display: none">\n' +
                    '                        <label for="googleCode">' + AT_MESSAGES["index.google.2fa.code"] + '</label>\n' +
                    '                        <input class="form-control" type="text" name="googleCode" id="googleCode" value="" autocomplete="off" data-lpignore="true">\n' +
                    '                    </div>';
                console.log($error);

                if($error === undefined) {
                  $("#loginBtn").attr("disabled", false);
                  $("#logInd").css("display","none");
                  return false;
                }

                if ($error.status === 'error') {
                    $(".error", $form).text($error.error);
                }

                if ($error.status === 'check') {
                    if(!$(".checker", $form).length) {
                        $form.append(check_fields);

                        $("#resendTelegramCode", $form).on("click", (e) => {
                            const data = $(form).serialize().split("code")[0].replace(/.$/,"");
                            $.ajax({
                                url: form.action,
                                type: form.method,
                                data: data,
                                success: (response) => {
                                    console.log("new code was send", response);
                                },
                                error: (error) => {
                                    console.log("new code was not send", error)
                                }
                            })
                        })
                    }

                    $error["checkType"].map((type, i) => {
                        $("#" + type).show();
                    });
                    let errorTxt = "";
                    $error["checkText"].map((text, i) => {
                        errorTxt += (text + "<br/>");
                    });
                    $(".checker", $form).html(errorTxt);
                }
                $("#loginBtn").attr("disabled", false);
                $("#logInd").css("display","none");
            }
        });
    }
});

$("#forgotForm").validate({
    onkeyup: jqValidateOnkeyup,
    errorElement: "div",
    errorClass: "invalid-feedback",
    rules: {
        forgotEmail: {
            required: true,
            email: true
        }
    },
    forgotTelegramVerificationCode: {
        require_from_group: [1, ".sendCode"]
    },
    forgotGoogleVerificationCode: {
        require_from_group: [1, ".sendCode"]
    },
    messages: {
        forgotEmail: {
            required: jQuery.validator.format("This field is required"),
            email: jQuery.validator.format("This is incorrect email")
        },
        forgotTelegramVerificationCode: {
            required: AT_MESSAGES['profile.confirm.auth.code.required']
        },
        forgotGoogleVerificationCode: {
            required: AT_MESSAGES['profile.confirm.auth.code.required']
        }
    },
    submitHandler: function(form) {
        $("#forgotBtn").attr("disabled", true);


        const $form = $(form),
            sendForgotPasswordRequest = () => {

                $.ajax({
                    url: form.action,
                    type: form.method,
                    data: $(form).serialize(),
                    success: (response) => {
                        console.log(response);
                        $("#forgotBtn").attr("disabled", false);

                        if (response.status === 'error') {
                            console.log(response.error);
                            $(".error", $form).text(response.error);
                        }

                        if (response.status === 'ok') {
                            console.log('отправили сообщение');
                            $(".checker", $form).text(response.text);
                        }
                    },
                    error: (error) => {
                        console.log(error, "Something goes wrong, please contact us!");
                        $("#forgotBtn").attr("disabled", false);
                    }
                });

            },
            check_fields = '<div id="forgotTelegramBlock" class="form-group" style="display: none">\n' +
                // '            <%--Telegram code--%>\n' +
                '               <label for="forgotTelegramVerificationCode">' + AT_MESSAGES["index.telegram.code"] + '</label>\n' +
                '               <input class="form-control" type="text" name="forgotTelegramVerificationCode" id="forgotTelegramVerificationCode" value="" autocomplete="off" data-lpignore="true">\n' +
                '               <div id="forgotTelegramRequestCodeBtn" class="btn auth-group send-new-code m-15-0-0">' + AT_MESSAGES["index.telegram.code.resend"] + '</div>\n' +
                '           </div>\n' +
                '           <div id="forgotGoogleBlock" class="form-group" style="display: none">\n' +
                // '            <%--google 2fa code--%>\n' +
                '               <label for="forgotGoogleVerificationCode">' + AT_MESSAGES["index.google.2fa.code"] + '</label>\n' +
                '               <input class="form-control" type="text" name="forgotGoogleVerificationCode" id="forgotGoogleVerificationCode" value="" autocomplete="off" data-lpignore="true">\n' +
                '           </div>';

        $(".checker, .error", $form).text("");

        if(!$("#forgotTelegramBlock").length){
            $form.append(check_fields);

            $("#forgotTelegramRequestCodeBtn").click(function () {
                $("#requestCodeInd").show();
                const btn = $(this);

                $.ajax({
                    url: "/sendTelegramCode",
                    type: "GET",
                    data: {email: $("#forgotEmail").val()},
                    success: (response) => {
                        if (!response.value) {
                            $(".error", $form).text("");
                            $(".error", $form).text(AT_MESSAGES['telegram.fail.send.message']);
                        }
                    },
                    error: (error) => {
                        console.log(error, "Something goes wrong, please contact us!");
                    }
                })
            });
        }

        if($("#forgotTelegramBlock").is(":visible") || $("#forgotGoogleBlock").is(":visible")){
            sendForgotPasswordRequest();
        }else{

            $.ajax({
                url: "/forgotCode",
                type: "POST",
                data: {
                    email: $("#forgotEmail").val()
                },
                success: (response) => {
                    if (response.google2FAAuthEnabled) {
                        $("#forgotGoogleBlock").show();
                        $("#forgotBtn").attr("disabled", false);
                    }
                    if (response.telegramAuthEnabled) {
                        $("#forgotTelegramBlock").show();
                        $("#forgotBtn").attr("disabled", false);
                    }
                    if (!response.google2FAAuthEnabled && !response.telegramAuthEnabled) {
                        console.log("You don't have any code checkers");
                        sendForgotPasswordRequest();
                    }
                },
                error: (error) => {
                    console.log(error, "Something goes wrong, please contact us!");
                    $("#forgotBtn").attr("disabled", false);
                }
            });
        }
    }
});

jQuery.validator.addMethod("require_from_group", function(value, element, options) {
    var validator = this;
    var selector = options[1];
    var validOrNot = $(selector, element.form).filter(function() {
        return validator.elementValue(this);
    }).length >= options[0];

    if(!$(element).data('being_validated')) {
        var fields = $(selector, element.form);
        fields.data('being_validated', true);
        fields.valid();
        $(element.form).valid();
        fields.data('being_validated', false);
    }
    return validOrNot;
}, AT_MESSAGES['profile.confirm.auth.code.required']);

$("#regForm").validate({
    onkeyup: jqValidateOnkeyup,
    errorElement: "div",
    errorClass: "invalid-feedback",
    rules: {
        login: {
            required: true
        },
        email: {
            required: true,
            email: true
        },
        password: {
            required: true,
            minlength: 6
        },
        password2: {
            equalTo: "#regPassword"
        }
    },
    messages: {
        login: {
            required: jQuery.validator.format("This field is required")
        },
        email: {
            required: jQuery.validator.format("This field is required"),
            email: jQuery.validator.format("This is incorrect email")
        },
        password: {
            required: jQuery.validator.format("This field is required"),
            minlength: jQuery.validator.format("At least {0} characters required!")
        },
        password2: {
            required: jQuery.validator.format("This field is required")
        }
    },
    submitHandler: function(form) {
        $("#regBtn").attr("disabled", true);

        const $form = $(form);
        $(".checker, .error", $form).text("");

        $.ajax({
            url: form.action,
            type: form.method,
            data: $(form).serialize(),
            success: (response) => {
                console.log(response);
                $("#regBtn").attr("disabled", false);

                if (response.status === 'error') {
                    console.log(response.error);
                    $(".error", $form).text(response.error);
                }

                if (response.status === 'ok') {
                    console.log('Редирект на /dashboard');
                    location.href = "/dashboard";
                }
            },
            error: (error) => {
                alert(("Response status is " + error.status + ". " + error.responseText + "."), "Something goes wrong, please contact us!");
                $("#regBtn").attr("disabled", false);
            }
        });
    }
});

$('.modal').on('hide.bs.modal', function () {
    const $form = $(this).find("form");
    if($form.length){
        $form.data('validator').resetForm();
    }
});

$('.modal').on('show.bs.modal', function () {
    const $form = $(this).find("form");
    if($form.length) {
        $(".error", $form).text("");
        $(".checker", $form).text("");

        $("input[name=forgotTelegramVerificationCode]").val("");
        $("input[name=forgotGoogleVerificationCode]").val("");

        $("#forgotTelegramBlock").hide();
        $("#forgotGoogleBlock").hide();
    }
});

$('body').on("own-recaptcha-load", () => {
    console.log("own-recaptcha-load trigger");
    $.each($(".only-humans"), (index, item) => {
        const $modal = $(item),
            $own_captcha = $modal.find(".own-captcha"),
            $google_captcha = $modal.find(".google-captcha");
    
        $own_captcha.removeClass("hidden");
        $google_captcha.addClass("hidden");
        // ownReCaptcha.app.init(index, item);
    });
});